import { render, staticRenderFns } from "./ProductMarketPlace.vue?vue&type=template&id=660c08f4&scoped=true&"
import script from "./ProductMarketPlace.vue?vue&type=script&lang=js&"
export * from "./ProductMarketPlace.vue?vue&type=script&lang=js&"
import style0 from "./ProductMarketPlace.vue?vue&type=style&index=0&id=660c08f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660c08f4",
  null
  
)

export default component.exports